import { LineHandling, Nomination } from "../models";

export const toOrdinalString = (number: number): string => {
  if (number <= 0) return number.toString();

  switch (number % 100) {
    case 11:
    case 12:
    case 13:
      return number + "th";
  }

  switch (number % 10) {
    case 1:
      return number + "st";
    case 2:
      return number + "nd";
    case 3:
      return number + "rd";
    default:
      return number + "th";
  }
};

export const toNominationNo = (
  nomination: Nomination | string | null
): string | null => {
  const nominationNo =
    nomination && typeof nomination !== "string"
      ? nomination.nominationNo
      : nomination;
  const splitNom = nominationNo && nominationNo?.split('-');
  
  if (nomination === null || nominationNo === null) {
    return null;
  } else if(splitNom && splitNom?.length > 3) {
      return splitNom.slice(2).join('-').trim();
  } else if (nominationNo.length > 6) {
    return nominationNo.substr(nominationNo.length - 5);
  } else {
    return nominationNo;
  }
};

export const toLineHandlingNo = (lineHandling: LineHandling): string => {
  const lineHandlingNo = lineHandling.lineHandlingNo;
  if (lineHandlingNo === null || lineHandlingNo === null) {
    return "";
  } else if (lineHandlingNo.length > 5) {
    return lineHandlingNo.substr(lineHandlingNo.length - 5);
  } else {
    return lineHandlingNo;
  }
};

export const last6Digits = (str: string | undefined): string => {
  if (str) {
    return str.length > 5 ? str.substr(str.length - 5) : str;
  }
  return "";
};
export const trimEmpty = (str: string): string =>
  str.trim() === "" ? "" : str;
export const stringify = (str?: string): string =>
  str === undefined ? "" : str;

export const groupBy = (array: any[], key: string) => {
  // Return the end result
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    );
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
};

export const getInitials = (name: string) =>
  name
    .split(" (")[0]
    .split(" ")
    .map((n, i, a) => (i === 0 || i + 1 === a.length ? n[0] : null))
    .join("");


export const blobToBase64 = (blob: any) => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise((resolve) => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};

export const convertStatusToName = (status: number) => {
    switch (status) {
        case 0: { return "Expected"; }
        case 1: { return "Arrived"; }
        case 2: { return "Departed"; }
        case 3: { return "Approved"; }
        case 4: { return "Rejected"; }
        case 5: { return "Halted"; }
        default: { return "Expected"; }
    }
}

export const convertLineHandlingStatusToName = (status: number) => {
  switch (status) {
      case 0: { return "Expected"; }
      case 1: { return "Arrived"; }
      case 3: { return "Departed"; }
      case 4: { return "Approved"; }
      case 6: { return "Tendered"; }
      default: { return "Expected"; }
  }
}

export const capitalizeFirstLetterPerWord = (str: string) => {
    return str
        .split(' ') // Split the string into an array of words
        .filter(word => word.length > 0) // Remove any empty words (extra spaces)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
        .join(' '); // Join the words back together into a single string
};
